import type { ContentBlock } from '@lic/types'

export function parseContent(raw: string): ContentBlock[] {
  if (raw.trim().startsWith('[')) {
    try {
      const parsed = JSON.parse(raw)
      if (Array.isArray(parsed)) return parsed as ContentBlock[]
    } catch {
      // fall through to plain-text conversion
    }
  }
  return raw
    .split('\n\n')
    .map((t) => t.trim())
    .filter(Boolean)
    .map((text): ContentBlock => ({ type: 'paragraph', text }))
}

export function serializeContent(blocks: ContentBlock[]): string {
  return JSON.stringify(blocks)
}
